/* Narrow accessibility fixes for markup injected by storefront apps. */
(() => {
  const selector = '.h2m-menu__desktop, .h2m-main-menu-item, #phntm-widget-host, .fgpw-product, img[src^="https://apxl.io/"]';
  let scheduled = false;

  function repairAppMarkup() {
    scheduled = false;

    // Hyper Menu uses the same list-item IDs for its mobile and desktop trees.
    // Keep mobile IDs intact: the app uses them for its mobile menu groups.
    const mobileIds = new Set(Array.from(
      document.querySelectorAll('.h2m-menu__mobile .h2m-main-menu-item[id]'),
      (item) => item.id
    ));
    document.querySelectorAll('.h2m-menu__desktop .h2m-main-menu-item[id]').forEach((item) => {
      if (!mobileIds.has(item.id)) return;
      const link = item.querySelector(':scope > a[id]');
      if (!link) return;
      const originalId = item.id;
      const uniqueId = `${link.id}-item`;
      if (document.getElementById(uniqueId)) return;
      item.id = uniqueId;

      // Preserve any local label/fragment associations, including future app updates.
      const nav = item.closest('.h2m-menu__desktop');
      nav.querySelectorAll('[aria-controls], [aria-labelledby], [aria-describedby], [for], [href]').forEach((element) => {
        ['aria-controls', 'aria-labelledby', 'aria-describedby', 'for'].forEach((attribute) => {
          const value = element.getAttribute(attribute);
          if (!value || !value.split(/\s+/).includes(originalId)) return;
          element.setAttribute(attribute, value.split(/\s+/).map((id) => id === originalId ? uniqueId : id).join(' '));
        });
        if (element.getAttribute('href') === `#${originalId}`) element.setAttribute('href', `#${uniqueId}`);
      });
    });

    // This 1px analytics image conveys no content. Leave its source/request intact.
    document.querySelectorAll('img[src^="https://apxl.io/"][width="1"][height="1"]').forEach((pixel) => {
      pixel.alt = '';
      pixel.setAttribute('aria-hidden', 'true');
    });

    // Free-gift buttons already show the same product name beside the thumbnail.
    document.querySelectorAll('button.fgpw-product img.fgpw-image[alt]').forEach((image) => {
      const name = image.alt.trim().replace(/\s+/g, ' ');
      const buttonText = image.closest('button').textContent.trim().replace(/\s+/g, ' ');
      if (name && buttonText.includes(name)) image.alt = '';
    });

    // The support app renders its tooltip inside an open shadow root.
    const support = document.getElementById('phntm-widget-host');
    if (support && !support.hasAttribute('role')) {
      support.setAttribute('role', 'complementary');
      support.setAttribute('aria-label', 'Customer support');
    }
  }

  function scheduleRepair() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(repairAppMarkup);
  }

  function start() {
    repairAppMarkup();
    new MutationObserver((records) => {
      const relevant = records.some((record) => {
        if (record.type === 'attributes') return record.target.matches('img[src^="https://apxl.io/"]');
        return Array.from(record.addedNodes).some((node) => node.nodeType === 1 &&
          (node.matches(selector) || node.querySelector(selector)));
      });
      if (relevant) scheduleRepair();
    }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['src']});
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once: true});
  else start();
})();
